import { branch, renderComponent } from 'recompose';
import Skeleton from './Skeleton';

export default branch(
    ({ leaderboards, error }) => !leaderboards && !error,
    renderComponent(Skeleton)
);
